import {Box, styled} from '@mui/material';

export const StyledBox = styled(Box)`
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
		max-width: 852px;
		align-items: center;
		margin: 0 auto;
	}
`;

export const ImageContainer = styled(Box)`
	margin-inline: auto;

	& img {
		max-width: 234px;
	}

	${({theme}) => theme.breakpoints.down('xl')} {
		& img {
			max-width: 168px;
		}
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		& img {
			max-width: 234px;
		}
	}
`;
